import React from "react";
import { SidebarProvider } from "@/components/ui/sidebar";
import { AdminSidebar } from "@/components/AdminSidebar";
import { AdminTopBar } from "@/components/AdminTopBar";
import GlobalAdminSoundAlert from "@/components/GlobalAdminSoundAlert";

interface AdminLayoutProps {
  children: React.ReactNode;
  title?: string;
  description?: string;
}

export function AdminLayout({ children, title, description }: AdminLayoutProps) {
  return (
    <AdminLayoutContent title={title} description={description}>
      {children}
    </AdminLayoutContent>
  );
}

function AdminLayoutContent({ children, title, description }: AdminLayoutProps) {
  return (
    <SidebarProvider>
      <GlobalAdminSoundAlert />
      
      <div className="min-h-screen flex w-full admin-layout-bg">
        <AdminSidebar />
        
        <div className="flex-1 flex flex-col min-w-0">
          <AdminTopBar />
          
          {/* Main Content */}
          <main className="flex-1 overflow-auto">
            <div className="p-4 md:p-6 lg:p-8 max-w-[1600px] mx-auto w-full animate-in fade-in duration-300">
              {children}
            </div>
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
}
